var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-viewer"},[_c('NavigationBar',{attrs:{"left-buttons":[{ text: 'Retour', back: true }],"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"app-view"},[_c('PdfDocument',{attrs:{"pdf-id":_vm.pdfId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }